interface HeroCopy {
  title: string;
  subtitle: string;
}

/** Retire the old publication without preventing subsequent editorial updates. */
export function resolveHomeHeroCopy(
  language: string,
  publication: { title?: string | null; subtitle?: string | null } | null,
  fallback: HeroCopy,
): HeroCopy {
  const title = publication?.title?.trim();
  const normalized = title?.replace(/\s+/gu, " ");
  if (
    language === "ru" &&
    normalized === "Социальная платформа, объединяющая людей на пути развития."
  )
    return fallback;
  return {
    title: title || fallback.title,
    subtitle: publication?.subtitle?.trim() || fallback.subtitle,
  };
}
